import Hero from '../components/sections/Hero';
import Promo from '../components/sections/Promo/Promo';
import About from '../components/sections/About/About';
import Topics from '../components/sections/Topics/Topics';
import Speakers from '../components/sections/Speakers/Speakers';
import Committee from '../components/sections/Committee/Committee';
import Partners from '../components/sections/Partners/Partners';
import Venue from '../components/sections/Venue/Venue';
import Programme from '../components/sections/Programme/Programme';
const sections = [

    Hero,

    Promo,

    About,

    Speakers,

    Committee,
    
    Programme,

    Venue,

    Partners

];

export default sections;
